// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  padding-left: 10px;
}

.removePhoto {
  height: 40px;
  width: 40px;
  background-color: #e74d33;
  border-radius: 22px;
  margin: 0 auto;
}

.icon {
  padding: 10px;
  height: 20px;
  width: 20px;
  color: white;
}

.galleryPhoto {
  height: 40px;
  width: 40px;
  background-color: #6f2a89;
  border-radius: 22px;
  margin: 0 auto;
}

.cameraPhoto {
  height: 40px;
  width: 40px;
  background-color: #92c45a;
  border-radius: 22px;
  margin: 0 auto;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/profile-photo-option/profile-photo-option.component.scss"],"names":[],"mappings":"AASE;EACE,kBAAA;AARJ;;AAUE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAPJ;;AASE;EACE,aAAA;EAOA,YAAA;EACA,WAAA;EACA,YAAA;AAZJ;;AAeE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAZJ;;AAeE;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AAZJ","sourcesContent":["\r\n\r\nion-content {\r\n    // --background: rgba(0, 0, 0, 0.270588) !important;\r\n  }\r\n  .container1 {\r\n    // background-color: #ffffff;\r\n    // color: black;\r\n  }\r\n  .title {\r\n    padding-left: 10px;\r\n  }\r\n  .removePhoto {\r\n    height: 40px;\r\n    width: 40px;\r\n    background-color: #e74d33;\r\n    border-radius: 22px;\r\n    margin: 0 auto;\r\n  }\r\n  .icon {\r\n    padding: 10px;\r\n    // font-size: 20px;\r\n    // color: white;\r\n    // display: flex;\r\n    // text-align: center;\r\n    // margin-left: 0.5em;\r\n  \r\n    height: 20px;\r\n    width: 20px;\r\n    color: white;\r\n}\r\n  \r\n  .galleryPhoto {\r\n    height: 40px;\r\n    width: 40px;\r\n    background-color: #6f2a89;\r\n    border-radius: 22px;\r\n    margin: 0 auto;\r\n}\r\n   \r\n  .cameraPhoto {\r\n    height: 40px;\r\n    width: 40px;\r\n    background-color: #92c45a;\r\n    border-radius: 22px;\r\n    margin: 0 auto;\r\n    text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
